import axios from "axios"

export const apiSetComercios = async (data:{}) => {
    return axios.post('api/Home/SetComercios',data)
}
